interface TinyCartItemProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

import cn from 'classnames';
import StarIcon from './stars.svg';
import TrustedShopIcon from './Trustbadge.svg';
/**
 * Fake trusted shop component
 */
export const TrustedShop: React.FC<TinyCartItemProps> = ({ className, ...props }) => {
  return (
    <div className={cn('flex items-center justify-between gap-2', className)} {...props}>
      <span>
        <TrustedShopIcon className="inline-block" /> Trusted Shop
      </span>
      <span className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <StarIcon key={i} />
        ))}
        <span className="text-primary-main text-sm">
          <span className="font-bold">4.72</span>/
          <span className="text-text-light-bg-secondary text-sm">5.00</span>
        </span>
      </span>
    </div>
  );
};
